function debounce(t, i) {
  let e;
  return function (...o) {
    const a = () => {
      (clearTimeout(e), t(...o));
    };
    (clearTimeout(e), (e = setTimeout(a, i)));
  };
}
function memoize(t) {
  const i = new Map();
  return function (...e) {
    const s = JSON.stringify(e);
    if (i.has(s)) return i.get(s);
    const o = t.apply(this, e);
    if ((i.set(s, o), i.size > 50)) {
      const a = i.keys().next().value;
      i.delete(a);
    }
    return o;
  };
}
async function withRetry(t, i = 3, e = 1e3) {
  let s;
  for (let o = 1; o <= i; o++)
    try {
      return await t();
    } catch (a) {
      if (
        ((s = a),
        a.message &&
          (a.message.includes("400") ||
            a.message.includes("validaci\xF3n") ||
            a.message.includes("Datos inv\xE1lidos") ||
            a.message.includes("Archivo inv\xE1lido")))
      )
        throw a;
      if (o < i) {
        const r = e * o;
        await new Promise((n) => setTimeout(n, r));
      }
    }
  throw new Error(`Fall\xF3 despu\xE9s de ${i} intentos: ${s.message}`);
}
const MATERIAL_MAP = {
  premium: "premium",
  // Aliases legacy pre-migración ago-2026 (carritos/_quoter_data viejos)
  vinyl: "premium",
  vinil: "premium",
  holo: "holografico",
  holografico: "holografico",
  iman: "iman",
  economico: "economico",
  sheets: "sheets",
  sheets_economicas: "sheets_economicas",
};
document.addEventListener("alpine:init", () => {
  Alpine.data("quoterApp", () => ({
    activeImageIndex: 0,
    ancho: 10,
    alto: 10,
    tamanoSeleccionado: "10x10",
    cantidad: 25,
    modoOtraCantidad: !1,
    tipoProducto: "sticker",
    materialActivo: "premium",
    numeroDisenos: 1,
    disenosSubidos: [],
    linkInstagram: "",
    modalInstagram: !1,
    inputInstagram: "",
    uploadError: "",
    uploadWarning: "",
    metodoEntrega: "upload",
    linkDescarga: "",
    cargandoCarrito: !1,
    isDragging: !1,
    subiendoArchivo: !1,
    indicacionesEspeciales: "",
    laminado: "",
    forma: "",
    mostrarModalConfirmacion: !1,
    mostrarModalOpciones: !1,
    uploadProgress: 0,
    uploadingFiles: !1,
    addingToCart: !1,
    errorAncho: "",
    errorAlto: "",
    errorCantidad: "",
    previewInstance: null,
    showPreviewGrid: !0,
    showPreviewComparison: !1,
    _cachedPrecio: null,
    _cacheKey: null,
    sessionId: null,
    apiDisponible: !0,
    _rafId: null,
    _configVersion: 0,
    init() {
      ((this.sessionId =
        typeof crypto < "u" && crypto.randomUUID
          ? crypto.randomUUID()
          : `${Date.now()}_${Math.random().toString(36).substr(2, 9)}`),
        window.AvexrhAPI &&
          window.AvexrhAPI.healthCheck().catch(() => {
            this.apiDisponible = !1;
          }),
        this.$nextTick(() => {
          (this.initPreview(),
            this.validarAncho(),
            this.validarAlto(),
            this.validarCantidad());
        }));
      const t = debounce(() => this.updatePreview(), 300);
      (this.$watch("ancho", () => {
        (this.invalidateCache(), this.validarAncho(), t());
      }),
        this.$watch("alto", () => {
          (this.invalidateCache(), this.validarAlto(), t());
        }),
        this.$watch("cantidad", () => {
          (this.invalidateCache(),
            this.numeroDisenos > this.disenosPermitidos &&
              (this.numeroDisenos = this.disenosPermitidos));
        }),
        this.$watch("materialActivo", () => this.invalidateCache()),
        this.$watch("disenosSubidos", () => t()),
        this.$watch("showPreviewGrid", () => this.updatePreview()),
        this.$watch("showPreviewComparison", () => this.updatePreview()));
      document.addEventListener("quoter:config-updated", () => {
        (this.invalidateCache && this.invalidateCache(), this._configVersion++);
      });
    },
    invalidateCache() {
      ((this._cachedPrecio = null), (this._cacheKey = null));
    },
    get precioActual() {
      void this._configVersion;
      if (!window.QuoterPricing) return this.resultadoVacio();
      const t = `${this.ancho}-${this.alto}-${this.cantidad}-${this.materialActivo}`;
      if (this._cacheKey === t && this._cachedPrecio) return this._cachedPrecio;
      const i = MATERIAL_MAP[this.materialActivo] || this.materialActivo,
        e = window.QuoterPricing.calcularPrecio(
          this.ancho,
          this.alto,
          this.cantidad,
          i,
        );
      return ((this._cacheKey = t), (this._cachedPrecio = e), e);
    },
    get tablaDePrecio() {
      void this._configVersion;
      if (!window.QuoterPricing || !this.ancho || !this.alto) return [];
      const t = MATERIAL_MAP[this.materialActivo] || this.materialActivo;
      return window.QuoterPricing.calcularTablaDePrecio(
        this.ancho,
        this.alto,
        t,
      );
    },
    get tablaDePrecioConDescuentos() {
      if (!this.tablaDePrecio || this.tablaDePrecio.length === 0) return [];
      const t = this.tablaDePrecio[0].precioUnitario;
      return this.tablaDePrecio.map((i) => {
        const e = t - i.precioUnitario,
          s = ((e / t) * 100).toFixed(0);
        return {
          ...i,
          descuento: e,
          porcentajeDescuento: parseInt(s),
          tieneDescuento: e > 0,
        };
      });
    },
    get filaOtraCantidad() {
      const t = this.tablaDePrecioConDescuentos;
      if (!t.length || !this.precioActual.valido) return null;
      const i = t[0].precioUnitario,
        e = i - this.precioActual.precios.unitarioConIva,
        s = e > 0 ? parseInt(((e / i) * 100).toFixed(0)) : 0;
      return {
        precioTotal: this.precioActual.precios.total,
        porcentajeDescuento: s,
        tieneDescuento: s > 0,
      };
    },
    get areaActual() {
      return this.ancho * this.alto;
    },
    get tieneDiseno() {
      return this.metodoEntrega === "upload"
        ? this.disenosSubidos.length > 0 ||
            (this.linkInstagram && this.linkInstagram.trim() !== "")
        : this.linkDescargaValido;
    },
    get estadoDiseno() {
      return this.disenosSubidos.length > 0
        ? `${this.disenosSubidos.length} dise\xF1o(s) subido(s)`
        : this.linkInstagram
          ? "Link de Instagram"
          : "";
    },
    get previewUrl() {
      return this.disenosSubidos.length > 0 && this.disenosSubidos[0].previewUrl
        ? this.disenosSubidos[0].previewUrl
        : null;
    },
    get disenosPermitidos() {
      const t = Math.floor(this.cantidad / 25);
      return Math.min(Math.max(t, 1), 10);
    },
    get puedeAgregarDiseno() {
      return this.disenosSubidos.length < this.numeroDisenos;
    },
    get tieneDiseniosExcedentes() {
      return this.disenosSubidos.length > this.disenosPermitidos;
    },
    get linkDescargaValido() {
      if (!this.linkDescarga || this.linkDescarga.trim() === "") return !1;
      try {
        return new URL(this.linkDescarga).protocol === "https:";
      } catch {
        return !1;
      }
    },
    get formularioValido() {
      return (
        !this.errorAncho &&
        !this.errorAlto &&
        !this.errorCantidad &&
        this.ancho > 0 &&
        this.alto > 0 &&
        this.cantidad >= 25 &&
        !this.tieneDiseniosExcedentes
      );
    },
    get desgloseDePrecios() {
      if (!this.precioActual.valido) return null;
      const t = this.precioActual;
      return {
        area: {
          label: "\xC1rea del sticker",
          calculo: `${t.dimensiones.ancho} \xD7 ${t.dimensiones.alto} cm`,
          valor: `${t.dimensiones.area} cm\xB2`,
        },
        costoMaterial: {
          label: "Costo de material",
          calculo: `${t.dimensiones.area} cm\xB2 \xD7 ${(window.QUOTER_CONFIG.materiales[t.material?.id]?.costFactor ?? 0).toFixed(4)}`,
          valor: this.formatearPrecio(t.costos.costoArea),
        },
        margen: {
          label: "Precio base unitario",
          calculo: `Para ${this.cantidad} piezas`,
          valor: this.formatearPrecio(t.precios.unitarioSinIva),
          multiplicador: `${t.costos.multiplicador.toFixed(1)}x`,
        },
        subtotal: {
          label: "Subtotal (sin IVA)",
          calculo: `${this.formatearPrecio(t.precios.unitarioSinIva)} \xD7 ${this.cantidad} pzas`,
          valor: this.formatearPrecio(t.precios.subtotal),
        },
        iva: {
          label: "IVA (16%)",
          calculo: "16% del subtotal",
          valor: this.formatearPrecio(t.precios.iva),
        },
        total: {
          label: "Total a pagar",
          valor: this.formatearPrecio(t.precios.total),
          unitario: this.formatearPrecio(t.precios.unitarioConIva) + " c/u",
        },
      };
    },
    get ahorroVsCantidadAnterior() {
      if (!this.tablaDePrecio || this.tablaDePrecio.length === 0) return null;
      const t = this.tablaDePrecio.findIndex(
        (r) => r.cantidad === this.cantidad,
      );
      if (t <= 0) return null;
      const i = this.tablaDePrecio[t],
        e = this.tablaDePrecio[t - 1],
        s = e.precioUnitario - i.precioUnitario,
        o = s * this.cantidad,
        a = ((s / e.precioUnitario) * 100).toFixed(0);
      return {
        cantidadAnterior: e.cantidad,
        precioAnterior: e.precioUnitario,
        precioActual: i.precioUnitario,
        ahorroPorPieza: s,
        ahorroTotal: o,
        porcentaje: a,
      };
    },
    formatearPrecio(t) {
      return window.QuoterPricing
        ? window.QuoterPricing.formatearPrecio(t)
        : "$0.00";
    },
    seleccionarCantidad(t) {
      ((this.cantidad = t), (this.modoOtraCantidad = !1));
    },
    seleccionarTamano(t, i, e) {
      if (((this.tamanoSeleccionado = t), t === "custom")) return;
      if (i === void 0 || e === void 0) {
        const s = String(t).split("x");
        ((i = parseFloat(s[0])), (e = parseFloat(s[1])));
      }
      !isNaN(i) &&
        !isNaN(e) &&
        ((this.ancho = i),
        (this.alto = e),
        this.validarAncho(),
        this.validarAlto());
    },
    cambiarTipoProducto(t) {
      ((this.tipoProducto = t),
        t === "iman"
          ? (this.materialActivo = "iman")
          : t === "sticker" &&
            this.materialActivo === "iman" &&
            (this.materialActivo = "premium"));
    },
    resultadoVacio() {
      return { valido: !1, precios: { unitarioConIva: 0, total: 0 } };
    },
    esMultiploDe(t, i) {
      if (!t || !i) return !1;
      const e = t / i,
        s = e - Math.floor(e);
      return Math.abs(s) < 0.001;
    },
    redondearAMultiplo(t, i = 0.5) {
      return Math.round(t / i) * i;
    },
    maxAncho() {
      return window.QUOTER_CONFIG.limites.anchoMax || 40;
    },
    maxAlto() {
      return window.QUOTER_CONFIG.limites.altoMax || 100;
    },
    validarAncho() {
      const t = window.QUOTER_CONFIG,
        i = t.limites.anchoMin,
        e = t.limites.incremento,
        s = this.maxAncho();
      if (this.ancho && this.ancho < i) {
        ((this.ancho = i),
          (this.errorAncho = `Ajustado al m\xEDnimo: ${i} cm`),
          setTimeout(() => (this.errorAncho = ""), 2e3));
        return;
      }
      if (this.ancho && this.ancho > s) {
        ((this.ancho = s),
          (this.errorAncho = `Ajustado al m\xE1ximo: ${s} cm`),
          setTimeout(() => (this.errorAncho = ""), 3e3));
        return;
      }
      if (this.ancho && !this.esMultiploDe(this.ancho, e)) {
        const o = this.redondearAMultiplo(this.ancho, e);
        ((this.ancho = Math.max(i, Math.min(s, o))),
          (this.errorAncho = `Ajustado a ${this.ancho} cm (m\xFAltiplo de ${e})`),
          setTimeout(() => (this.errorAncho = ""), 2e3));
        return;
      }
      this.errorAncho = "";
    },
    validarAlto() {
      const t = window.QUOTER_CONFIG,
        i = t.limites.altoMin,
        e = t.limites.incremento,
        s = this.maxAlto();
      if (this.alto && this.alto < i) {
        ((this.alto = i),
          (this.errorAlto = `Ajustado al m\xEDnimo: ${i} cm`),
          setTimeout(() => (this.errorAlto = ""), 2e3));
        return;
      }
      if (this.alto && this.alto > s) {
        ((this.alto = s),
          (this.errorAlto = `Ajustado al m\xE1ximo: ${s} cm`),
          setTimeout(() => (this.errorAlto = ""), 3e3));
        return;
      }
      if (this.alto && !this.esMultiploDe(this.alto, e)) {
        const o = this.redondearAMultiplo(this.alto, e);
        ((this.alto = Math.max(i, Math.min(s, o))),
          (this.errorAlto = `Ajustado a ${this.alto} cm (m\xFAltiplo de ${e})`),
          setTimeout(() => (this.errorAlto = ""), 2e3));
        return;
      }
      this.errorAlto = "";
    },
    validarCantidad() {
      const t = window.QUOTER_CONFIG,
        i = t.limites.cantidadMin,
        e = t.limites.cantidadMax;
      if (this.cantidad && this.cantidad < i) {
        ((this.cantidad = i),
          (this.errorCantidad = `Ajustada al m\xEDnimo: ${i} piezas`),
          setTimeout(() => (this.errorCantidad = ""), 2e3));
        return;
      }
      if (this.cantidad && this.cantidad > e) {
        ((this.cantidad = e),
          (this.errorCantidad = `Ajustada al m\xE1ximo: ${e.toLocaleString()} piezas`),
          setTimeout(() => (this.errorCantidad = ""), 2e3));
        return;
      }
      this.errorCantidad = "";
    },
    limitarInputCantidad(t) {
      if (
        [
          "Backspace",
          "Delete",
          "ArrowLeft",
          "ArrowRight",
          "Tab",
          "Home",
          "End",
        ].includes(t.key)
      )
        return;
      if ((t.ctrlKey || t.metaKey) && t.key.toLowerCase() === "v") {
        t.preventDefault();
        return;
      }
      if (t.ctrlKey || t.metaKey) return;
      if (!/^\d$/.test(t.key)) {
        t.preventDefault();
        return;
      }
      const e = t.target,
        s = e.value.substring(0, e.selectionStart),
        o = e.value.substring(e.selectionEnd),
        a = s + t.key + o,
        r = window.QUOTER_CONFIG.limites.cantidadMax;
      (a.length > String(r).length || parseInt(a, 10) > r) &&
        t.preventDefault();
    },
    procesarInputCantidad(t) {
      const i = t.target,
        e = i.value.replace(/[^0-9]/g, ""),
        s = window.QUOTER_CONFIG.limites.cantidadMax,
        o = String(s).length,
        a = e.substring(0, o),
        r = Math.min(parseInt(a, 10) || 0, s),
        n = a ? String(r) : "";
      i.value !== n && ((i.value = n), (this.cantidad = r));
    },
    manejarPegadoCantidad(t) {
      t.preventDefault();
      const i = (t.clipboardData || window.clipboardData).getData("text"),
        e = parseInt(i.replace(/\D/g, ""), 10),
        s = window.QUOTER_CONFIG;
      isNaN(e) ||
        (this.cantidad = Math.min(
          Math.max(e, s.limites.cantidadMin),
          s.limites.cantidadMax,
        ));
    },
    triggerFileUpload() {
      this.$refs.fileInput.click();
    },
    async handleFileUpload(t) {
      const i = t.target.files[0];
      i && (await this.processFile(i));
    },
    async processFile(t) {
      if (!this.puedeAgregarDiseno) {
        ((this.uploadError = `Ya subiste ${this.numeroDisenos} dise\xF1o(s). Elimina uno o aumenta el n\xFAmero de dise\xF1os.`),
          setTimeout(() => (this.uploadError = ""), 4e3));
        return;
      }
      const i = [
          "image/png",
          "image/jpeg",
          "image/jpg",
          "application/pdf",
          "application/postscript",
        ],
        e = [".png", ".jpg", ".jpeg", ".pdf", ".ai"],
        s = "." + t.name.split(".").pop().toLowerCase();
      if (!i.includes(t.type) && !e.includes(s)) {
        ((this.uploadError = "Formato no v\xE1lido. Usa PNG, JPG, PDF o AI"),
          setTimeout(() => (this.uploadError = ""), 3e3));
        return;
      }
      const o = 50 * 1024 * 1024;
      if (t.size > o) {
        ((this.uploadError = "Archivo muy grande. M\xE1ximo 50MB"),
          setTimeout(() => (this.uploadError = ""), 3e3));
        return;
      }
      ((this.uploadError = ""),
        (this.uploadWarning = ""),
        (this.subiendoArchivo = !0));
      const a = {
        id: Date.now(),
        archivo: t,
        nombre: t.name,
        tamano: (t.size / 1024 / 1024).toFixed(2) + " MB",
        tipo: t.type || "Desconocido",
        previewUrl: null,
        urlR2: null,
        subiendo: !0,
        dimensiones: null,
      };
      this.disenosSubidos.push(a);
      const r = this.disenosSubidos.length - 1;
      if (
        ((this.disenosSubidos[r].subiendo = !1),
        (this.subiendoArchivo = !1),
        t.type.startsWith("image/"))
      ) {
        const n = new FileReader();
        ((n.onload = (l) => {
          this.disenosSubidos[r].previewUrl = l.target.result;
          const c = new Image();
          ((c.onload = () => {
            const d = c.width,
              h = c.height;
            this.disenosSubidos[r].dimensiones = `${d} \xD7 ${h} px`;
            const u = 300,
              m = 0.393701,
              f = this.ancho * m,
              v = this.alto * m,
              p = f * u,
              g = v * u;
            (d < p || h < g) &&
              ((this.uploadWarning = `\u26A0\uFE0F "${t.name}" tiene resoluci\xF3n baja. Recomendamos al menos ${Math.ceil(p)} \xD7 ${Math.ceil(g)} px.`),
              setTimeout(() => (this.uploadWarning = ""), 5e3));
          }),
            (c.src = l.target.result));
        }),
          n.readAsDataURL(t));
      }
    },
    handleDragEnter(t) {
      (t.preventDefault(), (this.isDragging = !0));
    },
    handleDragLeave(t) {
      (t.preventDefault(), (this.isDragging = !1));
    },
    handleDragOver(t) {
      t.preventDefault();
    },
    async handleDrop(t) {
      (t.preventDefault(), (this.isDragging = !1));
      const i = t.dataTransfer.files;
      i.length > 0 && (await this.processFile(i[0]));
    },
    abrirModalInstagram() {
      ((this.inputInstagram = this.linkInstagram || ""),
        (this.modalInstagram = !0));
    },
    confirmarInstagram() {
      const t = this.inputInstagram.trim();
      if (!t) {
        this.modalInstagram = !1;
        return;
      }
      if (!t.includes("instagram.com")) {
        ((this.uploadError = "Link inv\xE1lido. Debe ser de Instagram"),
          setTimeout(() => (this.uploadError = ""), 3e3));
        return;
      }
      ((this.linkInstagram = t),
        (this.uploadError = ""),
        (this.modalInstagram = !1));
    },
    cerrarModalInstagram() {
      ((this.modalInstagram = !1), (this.inputInstagram = ""));
    },
    eliminarDiseno(t) {
      this.disenosSubidos = this.disenosSubidos.filter((i) => i.id !== t);
    },
    limpiarDisenos() {
      ((this.disenosSubidos = []),
        (this.linkInstagram = ""),
        (this.linkDescarga = ""),
        (this.uploadError = ""),
        (this.uploadWarning = ""),
        (this.isDragging = !1),
        (this.subiendoArchivo = !1),
        this.$refs.fileInput && (this.$refs.fileInput.value = ""));
    },
    cambiarMetodoEntrega(t) {
      this.metodoEntrega !== t &&
        ((this.metodoEntrega = t),
        t === "upload"
          ? (this.linkDescarga = "")
          : ((this.disenosSubidos = []),
            (this.linkInstagram = ""),
            this.$refs.fileInput && (this.$refs.fileInput.value = "")),
        (this.uploadError = ""),
        (this.uploadWarning = ""));
    },
    mostrarConfirmacion() {
      if (this.validarCotizacion()) {
        this.mostrarModalConfirmacion = true;
        document.body.classList.add("quoter-modal-open");
      }
    },

    cerrarConfirmacion() {
      this.mostrarModalConfirmacion = false;
      document.body.classList.remove("quoter-modal-open");
    },
    get resumenPedido() {
      const i = window.QUOTER_CONFIG.materiales[this.materialActivo];
      return {
        material: i ? i.nombre : this.materialActivo,
        ancho: this.ancho,
        alto: this.alto,
        area: this.areaActual,
        cantidad: this.cantidad,
        precioUnitario: this.precioActual.precios?.unitarioConIva || 0,
        precioTotal: this.precioActual.precios?.total || 0,
        disenosCount: this.disenosSubidos.length,
        disenos: this.disenosSubidos.map((e) => e.nombre),
        tieneInstagram: !!this.linkInstagram,
        indicaciones: this.indicacionesEspeciales,
        laminado: this.laminado,
        forma: this.forma,
      };
    },
    async subirDisenosAR2() {
      const t = this.disenosSubidos.filter((a) => a.archivo && !a.urlR2);
      if (t.length === 0) return [];
      ((this.uploadingFiles = !0), (this.uploadProgress = 0));
      const i = t.length;
      let e = 0;
      const s = [];
      for (const a of t)
        try {
          const r = (l) => {
              const c = (e / i) * 100,
                d = l / i;
              this.uploadProgress = Math.round(c + d);
            },
            n = await withRetry(
              async () =>
                await window.AvexrhAPI.uploadDesign(
                  a.archivo,
                  this.sessionId,
                  r,
                ),
              3,
              2e3,
            );
          if (n.success && n.data.url) {
            const l = this.disenosSubidos.findIndex((c) => c.id === a.id);
            (l !== -1 && (this.disenosSubidos[l].urlR2 = n.data.url),
              s.push({ success: !0, nombre: a.nombre, url: n.data.url }));
          } else
            s.push({
              success: !1,
              nombre: a.nombre,
              error: "Sin URL en respuesta",
            });
          (e++, (this.uploadProgress = Math.round((e / i) * 100)));
        } catch (r) {
          (s.push({ success: !1, nombre: a.nombre, error: r.message }), e++);
        }
      ((this.uploadingFiles = !1), (this.uploadProgress = 100));
      const o = s.filter((a) => !a.success);
      if (o.length > 0) {
        const a = o.map((r) => r.nombre).join(", ");
        throw new Error(`No se pudieron subir: ${a}`);
      }
      return s;
    },
    async agregarAlCarrito() {
      this.mostrarModalConfirmacion = false;
      document.body.classList.remove("quoter-modal-open");

      if (!this.addingToCart && this.validarCotizacion()) {
        if (!window.AvexrhAPI) {
          this.mostrarMensajeError(
            "No se pudo conectar con el servidor. Recarga la p\xE1gina e intenta de nuevo.",
          );
          return;
        }
        if (!window.QuoterCart) return this.agregarAlCarritoDirecto();
        ((this.addingToCart = !0), (this.cargandoCarrito = !0));
        try {
          this.metodoEntrega === "upload" &&
            this.disenosSubidos.length > 0 &&
            (await this.subirDisenosAR2());
          const t = MATERIAL_MAP[this.materialActivo] || "premium",
            i = this.prepararDisenosParaEnvio(),
            { shopifyResponse: e } = await withRetry(
              async () =>
                await window.QuoterCart.addItem({
                  producto: t,
                  ancho: parseFloat(this.ancho),
                  alto: parseFloat(this.alto),
                  cantidad: parseInt(this.cantidad),
                  disenos: i,
                  sessionId: this.sessionId,
                  precioTotal: this.precioActual.precios?.total || 0,
                  precioUnitario:
                    this.precioActual.precios?.unitarioConIva || 0,
                  indicaciones: this.indicacionesEspeciales || "",
                  laminado: this.laminado || "",
                  forma: this.forma || "",
                }),
              2,
              1500,
            );
          (await this.actualizarCarritoConSecciones(e),
            this.prepararNuevoPedido());
        } catch (t) {
          if (
            (this.mostrarMensajeError(
              t.message ||
                "Hubo un error al agregar al carrito. Por favor intenta de nuevo.",
            ),
            this.sessionId &&
              window.AvexrhAPI &&
              this.disenosSubidos.some((i) => i.urlR2))
          )
            try {
              (await window.AvexrhAPI.deleteSession(this.sessionId),
                this.disenosSubidos.forEach((i) => {
                  i.urlR2 = null;
                }),
                this.mostrarMensajeError(
                  "Los archivos subidos fueron eliminados autom\xE1ticamente. Puedes intentar de nuevo.",
                ));
            } catch (i) {
              (this.disenosSubidos.forEach((e) => {
                e.urlR2 = null;
              }),
                console.error("Error en rollback:", i));
            }
        } finally {
          ((this.addingToCart = !1),
            (this.cargandoCarrito = !1),
            (this.uploadProgress = 0));
        }
      }
    },
    async agregarAlCarritoDirecto() {
      this.cargandoCarrito = !0;
      try {
        this.metodoEntrega === "upload" &&
          this.disenosSubidos.length > 0 &&
          (await this.subirDisenosAR2());
        const t = MATERIAL_MAP[this.materialActivo] || "premium",
          i = this.prepararDisenosParaEnvio();
        let e = this.obtenerInfoDiseno();
        this.indicacionesEspeciales &&
          (e +=
            `

Indicaciones: ` + this.indicacionesEspeciales);
        const s = await window.AvexrhAPI.createDraftOrder({
          producto: t,
          ancho: parseFloat(this.ancho),
          alto: parseFloat(this.alto),
          cantidad: parseInt(this.cantidad),
          disenos: i,
          indicacionesEspeciales: e,
          laminado: this.laminado || "",
          forma: this.forma || "",
          sessionId: this.sessionId,
          primeraCompra: !!(
            window.AVEXRH_CUSTOMER &&
            window.AVEXRH_CUSTOMER.loggedIn &&
            window.AVEXRH_CUSTOMER.ordersCount === 0
          ),
        });
        (this.mostrarMensajeExito("\xA1Redirigiendo al checkout..."),
          setTimeout(() => {
            window.location.href = s.data.invoiceUrl;
          }, 1e3));
      } catch (t) {
        this.mostrarMensajeError(t.message || "Error al procesar el pedido.");
      } finally {
        this.cargandoCarrito = !1;
      }
    },
    prepararNuevoPedido() {
      ((this.sessionId =
        typeof crypto < "u" && crypto.randomUUID
          ? crypto.randomUUID()
          : `${Date.now()}_${Math.random().toString(36).substr(2, 9)}`),
        (this.disenosSubidos = []),
        (this.linkInstagram = ""),
        (this.linkDescarga = ""),
        (this.indicacionesEspeciales = ""),
        (this.laminado = ""),
        (this.forma = ""),
        (this.uploadProgress = 0),
        this.$refs.fileInput && (this.$refs.fileInput.value = ""));
    },
    seguirComprando() {
      this.mostrarModalOpciones = false;
      document.body.classList.remove("quoter-modal-open");
    },
    irAlCarrito() {
      this.mostrarModalOpciones = false;
      document.body.classList.remove("quoter-modal-open");
      window.location.href = "/cart";
    },
    async irAlCheckout() {
      this.mostrarModalOpciones = false;
      document.body.classList.remove("quoter-modal-open");
      window.QuoterCheckout
        ? await window.QuoterCheckout.processCheckout()
        : (window.location.href = "/checkout");
    },
    async actualizarCarritoConSecciones(t) {
      try {
        const e = await (await fetch("/cart.js")).json();
        (document
          .querySelectorAll(
            "hdt-cart-count, .hdt-count-box, .cart-count, [data-cart-count]",
          )
          .forEach((o) => {
            o.textContent = e.item_count;
          }),
          t && t.sections
            ? document.dispatchEvent(
                new CustomEvent("cart:change", {
                  bubbles: !0,
                  detail: {
                    baseEvent: "variant:add",
                    cart: { sections: t.sections, item_count: e.item_count },
                  },
                }),
              )
            : document.dispatchEvent(
                new CustomEvent("cart:refresh", { bubbles: !0 }),
              ));
      } catch {
        document.dispatchEvent(
          new CustomEvent("cart:refresh", { bubbles: !0 }),
        );
      }
    },
    validarCotizacion() {
      return (
        this.validarAncho(),
        this.validarAlto(),
        this.validarCantidad(),
        this.errorAncho
          ? (this.mostrarMensajeError(this.errorAncho), !1)
          : this.errorAlto
            ? (this.mostrarMensajeError(this.errorAlto), !1)
            : this.errorCantidad
              ? (this.mostrarMensajeError(this.errorCantidad), !1)
              : this.precioActual.valido
                ? !0
                : (this.mostrarMensajeError(
                    "No se pudo calcular el precio. Por favor verifica las dimensiones.",
                  ),
                  !1)
      );
    },
    prepararDisenosParaEnvio() {
      const t = [];
      if (this.metodoEntrega === "upload") {
        for (const i of this.disenosSubidos)
          t.push({ nombre: i.nombre, url: i.urlR2 || "Pendiente" });
        this.linkInstagram &&
          this.linkInstagram.trim() &&
          t.push({ nombre: "Instagram", url: this.linkInstagram });
      } else
        this.metodoEntrega === "link" &&
          this.linkDescarga &&
          t.push({
            nombre: "Link de descarga",
            url: this.linkDescarga,
            tipo: "link_externo",
          });
      return t;
    },
    obtenerInfoDiseno() {
      const t = [];
      if (this.disenosSubidos.length > 0) {
        const i = this.disenosSubidos.map((e) => e.nombre).join(", ");
        t.push(`Archivos (${this.disenosSubidos.length}): ${i}`);
      }
      return (
        this.linkInstagram &&
          this.linkInstagram.trim() &&
          t.push(`Instagram: ${this.linkInstagram}`),
        t.length > 0
          ? t.join(`
`)
          : "Por definir (enviar por correo)"
      );
    },
    mostrarMensajeExito(t = null) {
      const i = document.createElement("div");
      ((i.className = "quoter-toast quoter-toast--success"),
        (i.innerHTML = `
        <svg fill="currentColor" viewBox="0 0 20 20" style="width: 24px; height: 24px;">
          <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
        </svg>
        <span>${t || "\xA1Producto agregado al carrito!"}</span>
      `),
        document.body.appendChild(i),
        setTimeout(() => {
          (i.classList.add("quoter-toast--closing"),
            setTimeout(() => i.remove(), 300));
        }, 3e3));
    },
    mostrarMensajeError(t) {
      const i = document.createElement("div");
      ((i.className = "quoter-toast quoter-toast--error"),
        i.setAttribute("role", "alert"),
        i.setAttribute("aria-live", "assertive"),
        i.setAttribute("aria-atomic", "true"));
      const e = document.createElement("div");
      ((e.className = "quoter-toast__content"),
        (e.innerHTML =
          '<svg fill="currentColor" viewBox="0 0 20 20" style="width: 24px; height: 24px; flex-shrink: 0;"><path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/></svg>'));
      const s = document.createElement("span");
      ((s.textContent = t), e.appendChild(s));
      const o = document.createElement("button");
      ((o.className = "quoter-toast__close"),
        o.setAttribute("aria-label", "Cerrar mensaje"),
        (o.innerHTML =
          '<svg fill="currentColor" viewBox="0 0 20 20" style="width: 18px; height: 18px;" aria-hidden="true"><path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"/></svg>'),
        o.addEventListener("click", () => i.remove()),
        i.appendChild(e),
        i.appendChild(o),
        document.body.appendChild(i),
        setTimeout(() => {
          i.parentElement &&
            (i.classList.add("quoter-toast--closing"),
            setTimeout(() => i.remove(), 300));
        }, 5e3));
    },
    initPreview() {
      const t = this.$refs.previewCanvas;
      if (!t || !window.QuoterPreview) return;
      ((this.previewInstance = window.QuoterPreview.init(t, {
        showGrid: this.showPreviewGrid,
        compareObjects: this.showPreviewComparison,
        backgroundColor: "#f8f9fa",
        stickerColor: "#ffffff",
        borderColor: "#dee2e6",
        laptopImageUrl: window.QUOTER_LAPTOP_IMAGE || null,
      })),
        (this._canvasVisible = !0),
        (this._previewPending = !1),
        "IntersectionObserver" in window &&
          ((this._canvasObserver = new IntersectionObserver(
            (o) => {
              ((this._canvasVisible = o[0].isIntersecting),
                this._canvasVisible &&
                  this._previewPending &&
                  ((this._previewPending = !1), this.updatePreview()));
            },
            { threshold: 0.1 },
          )),
          this._canvasObserver.observe(t)));
      const i = t.clientWidth || 500,
        e = t.clientHeight || 400;
      this.previewInstance.resize(i, e);
      const s = debounce(() => {
        if (this.previewInstance && t) {
          const o = t.clientWidth || 500,
            a = t.clientHeight || 400;
          (this.previewInstance.resize(o, a), this.updatePreview());
        }
      }, 300);
      (window.addEventListener("orientationchange", s),
        window.addEventListener("resize", s),
        this.updatePreview());
    },
    updatePreview() {
      if (!this.previewInstance) return;
      if (!this._canvasVisible) { this._previewPending = !0; return; }
      if (this._rafId) return;
      this._rafId = requestAnimationFrame(() => {
        this._rafId = null;
        if (!this.previewInstance) return;
        (this.previewInstance.setOption("showGrid", this.showPreviewGrid),
          this.previewInstance.setOption(
            "compareObjects",
            this.showPreviewComparison,
          ),
          this.previewInstance.render(
            parseFloat(this.ancho) || 10,
            parseFloat(this.alto) || 10,
            this.previewUrl,
          ));
      });
    },
    togglePreviewGrid() {
      ((this.showPreviewGrid = !0), (this.showPreviewComparison = !1));
    },
    togglePreviewComparison() {
      ((this.showPreviewComparison = !this.showPreviewComparison),
        this.showPreviewComparison && (this.showPreviewGrid = !1));
    },
    _longPressInterval: null,
    _longPressTimeout: null,
    _stepperStep: 1,
    incrementarCantidad(t = null) {
      const i = t || this._stepperStep,
        s = window.QUOTER_CONFIG.limites.cantidadMax,
        o = this.cantidad + i;
      o <= s ? (this.cantidad = o) : (this.cantidad = s);
    },
    decrementarCantidad(t = null) {
      const i = t || this._stepperStep,
        s = window.QUOTER_CONFIG.limites.cantidadMin,
        o = this.cantidad - i;
      o >= s ? (this.cantidad = o) : (this.cantidad = s);
    },
    get puedeIncrementar() {
      const t = window.QUOTER_CONFIG;
      return this.cantidad < t.limites.cantidadMax;
    },
    get puedeDecrementar() {
      const t = window.QUOTER_CONFIG;
      return this.cantidad > t.limites.cantidadMin;
    },
    iniciarLongPress(t) {
      (this.detenerLongPress(),
        t === "incrementar"
          ? this.incrementarCantidad()
          : this.decrementarCantidad(),
        (this._longPressTimeout = setTimeout(() => {
          this._longPressInterval = setInterval(() => {
            t === "incrementar"
              ? this.incrementarCantidad()
              : this.decrementarCantidad();
          }, 100);
        }, 300)));
    },
    detenerLongPress() {
      (this._longPressTimeout &&
        (clearTimeout(this._longPressTimeout), (this._longPressTimeout = null)),
        this._longPressInterval &&
          (clearInterval(this._longPressInterval),
          (this._longPressInterval = null)));
    },
    incrementarAncho() {
      const i = window.QUOTER_CONFIG.limites.incremento || 0.5,
        e = this.maxAncho(),
        s = Math.round((this.ancho + i) * 10) / 10;
      s <= e && (this.ancho = s);
    },
    decrementarAncho() {
      const t = window.QUOTER_CONFIG,
        i = t.limites.incremento || 0.5,
        e = t.limites.anchoMin || 4,
        s = Math.round((this.ancho - i) * 10) / 10;
      s >= e && (this.ancho = s);
    },
    get puedeIncrementarAncho() {
      const i = window.QUOTER_CONFIG.limites.incremento || 0.5,
        e = this.maxAncho();
      return this.ancho + i <= e;
    },
    get puedeDecrementarAncho() {
      const t = window.QUOTER_CONFIG,
        i = t.limites.incremento || 0.5,
        e = t.limites.anchoMin || 4;
      return this.ancho - i >= e;
    },
    incrementarAlto() {
      const i = window.QUOTER_CONFIG.limites.incremento || 0.5,
        e = this.maxAlto(),
        s = Math.round((this.alto + i) * 10) / 10;
      s <= e && (this.alto = s);
    },
    decrementarAlto() {
      const t = window.QUOTER_CONFIG,
        i = t.limites.incremento || 0.5,
        e = t.limites.altoMin || 4,
        s = Math.round((this.alto - i) * 10) / 10;
      s >= e && (this.alto = s);
    },
    get puedeIncrementarAlto() {
      const i = window.QUOTER_CONFIG.limites.incremento || 0.5,
        e = this.maxAlto();
      return this.alto + i <= e;
    },
    get puedeDecrementarAlto() {
      const t = window.QUOTER_CONFIG,
        i = t.limites.incremento || 0.5,
        e = t.limites.altoMin || 4;
      return this.alto - i >= e;
    },
    iniciarLongPressDimension(t) {
      (this.detenerLongPress(),
        this[t](),
        (this._longPressTimeout = setTimeout(() => {
          this._longPressInterval = setInterval(() => {
            this[t]();
          }, 150);
        }, 400)));
    },
  }));
});
